import JoyField from '../types/JoyField';
import JoyObjectType from '../types/objects/JoyObjectType';
import JoyObject from './JoyObject';
import JoyDataService from '../services/JoyDataService';
import { isJoyCommentType, isJoyStatus } from '../validation/ModelValidation';
import { isString, isNumber } from '../validation/TypeChecking';
export default class JoyComment extends JoyObject {
    /**
     * Create a new JoyComment object.
     * @param data A map of JoyField/value pairs that define the object properties.
     */
    constructor(data) {
        super({
            id: data[JoyField.id],
            objectId: data[JoyField.objectId],
            createdAt: data[JoyField.createdAt],
            createdBy: data[JoyField.createdBy],
        });
        this.fields = [JoyField.content, JoyField.duration];
        this.objectType = JoyObjectType.comment;
        //Helpers
        this.update = (update) => {
            console.log('new updates for comment: ' + this.id);
            let changes = [];
            let status = update[JoyField.status];
            if (isJoyStatus(status) && this._status !== status) {
                this._status = status;
                changes.push(JoyField.status);
            }
            let content = update[JoyField.content];
            if (isString(content)) {
                let exists = isString(this._content);
                if (!exists || (exists && this._content !== content)) {
                    this._content = content;
                    changes.push(JoyField.content);
                }
            }
            let duration = update[JoyField.duration];
            if (isNumber(duration)) {
                let exists = isNumber(this._duration);
                if (!exists || (exists && this._duration !== duration)) {
                    this._duration = duration;
                    changes.push(JoyField.duration);
                }
            }
            if (changes.length > 0) {
                super.notifyObservers(changes);
            }
        };
        if (!isString(data[JoyField.group])) {
            throw Error('Invalid field group.');
        }
        this.groupId = data[JoyField.group];
        if (!isString(data[JoyField.medium])) {
            throw Error('Invalid field medium.');
        }
        this.mediumId = data[JoyField.medium];
        if (!isJoyCommentType(data[JoyField.commentType])) {
            throw Error('Invalid field commentType.');
        }
        this.type = data[JoyField.commentType];
        if (!isJoyStatus(data[JoyField.status])) {
            throw Error('Invalid field status.');
        }
        this._status = data[JoyField.status];
        if (isString(data[JoyField.content])) {
            this._content = data[JoyField.content];
        }
        else {
            this._content = null;
        }
        if (isNumber(data[JoyField.duration])) {
            this._duration = data[JoyField.duration];
        }
        else {
            this._duration = null;
        }
        this.initialUpdate = JoyComment.fields;
        let listenerData = new Map();
        listenerData[JoyField.objectType] = this.objectType;
        listenerData[JoyField.id] = this.id;
        listenerData[JoyField.medium] = this.mediumId;
        listenerData[JoyField.group] = this.groupId;
        this.listener = JoyDataService.instance.documentListener(listenerData, this.update);
    }
    get status() {
        return this._status;
    }
    get content() {
        return this._content;
    }
    get duration() {
        return this._duration;
    }
    /**
     * Set the content field of the document.
     * @param content A string.
     */
    async setContent(content) {
        let data = new Map();
        data[JoyField.content] = content;
        data[JoyField.medium] = this.mediumId;
        data[JoyField.group] = this.groupId;
        return this.updateData(data);
    }
}
//# sourceMappingURL=JoyComment.js.map